export const HORIZONTAL = "horizontal";
export const VERTICAL = "vertical";

export const RECURSIVE_DIVISON = "Recursive Division";
export const RANDOM = "Random";

export const A_STAR = "A*";
export const GREEDY_BFS = "Greedy Best-First Search";
export const BFS = "Breadth-first Search";
export const DFS = "Depth-first Search";

export const ANIMATION_MAZE_TIME = 10;
export const ANIMATION_VISITED_NODE_TIME = 10;
export const ANIMATION_PATH_NODE_TIME = 30;